<nav class="sidebar" [class.expanded]="isExpanded">

  <div class="nav-toggle">
    <button class="nav-item toggle-btn" (click)="toggle()" [title]="'Fechar menu' | translate">
      <span class="nav-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
             fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </span>
      <span class="nav-label">{{ 'Fechar' | translate }}</span>
    </button>
  </div>

  <ul class="nav-list">
    <li>
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
         class="nav-item" (click)="close()" title="{{ 'Home' | translate }}">
        <span class="nav-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
               fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
            <polyline points="9 22 9 12 15 12 15 22"/>
          </svg>
        </span>
        <span class="nav-label">{{ 'Home' | translate }}</span>
      </a>
    </li>

    <li>
      <a routerLink="/receitas-pending-issues" routerLinkActive="active"
         class="nav-item" (click)="close()" title="{{ 'Receitas em Validação' | translate }}">
        <span class="nav-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
               fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
          </svg>
        </span>
        <span class="nav-label">{{ 'Receitas em Validação' | translate }}</span>
      </a>
    </li>

    <!-- Performance do Usuário (tela antiga) desativada: substituída por "Prescrições por Usuário".
    <li *ngIf="isAdminUser || isAdmiGruponUser || isAdmiGlobalGruponUser">
      <a routerLink="/performance" routerLinkActive="active"
         class="nav-item" (click)="close()" title="{{ 'Performance do Usuário' | translate }}">
        <span class="nav-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
               fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="20" x2="18" y2="10"/>
            <line x1="12" y1="20" x2="12" y2="4"/>
            <line x1="6" y1="20" x2="6" y2="14"/>
          </svg>
        </span>
        <span class="nav-label">{{ 'Performance do Usuário' | translate }}</span>
      </a>
    </li>
    -->

    <!-- <li *ngIf="isAdminUser || isAdmiGruponUser || isAdmiGlobalGruponUser"> -->
    <li>
      <a routerLink="/performance-reviews" routerLinkActive="active"
         class="nav-item" (click)="close()" title="{{ 'Prescrições por Usuário' | translate }}">
        <span class="nav-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
               fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
          </svg>
        </span>
        <span class="nav-label">{{ 'Prescrições por Usuário' | translate }}</span>
      </a>
    </li>

    <li *ngIf="isAdminUser || isAdmiGruponUser || isAdmiGlobalGruponUser">
      <a routerLink="/grupo-lista" routerLinkActive="active"
         class="nav-item" (click)="close()" title="{{ 'Lista de grupos' | translate }}">
        <span class="nav-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
               fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
        </span>
        <span class="nav-label">{{ 'Lista de grupos' | translate }}</span>
      </a>
    </li>

    <li>
      <a routerLink="/relatorio-intervencoes" routerLinkActive="active"
         class="nav-item" (click)="close()" title="{{ 'Relatório Interação Usuário' | translate }}">
        <span class="nav-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
               fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
            <line x1="3" y1="9" x2="21" y2="9"/>
            <line x1="3" y1="15" x2="21" y2="15"/>
            <line x1="9" y1="9" x2="9" y2="21"/>
          </svg>
        </span>
        <span class="nav-label">{{ 'Relatório Interação Usuário' | translate }}</span>
      </a>
    </li>

    <li *ngIf="isAdminUser">
      <a routerLink="/diretorio-lista" routerLinkActive="active"
         class="nav-item" (click)="close()" title="{{ 'Lista de diretórios' | translate }}">
        <span class="nav-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
               fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
          </svg>
        </span>
        <span class="nav-label">{{ 'Lista de diretórios' | translate }}</span>
      </a>
    </li>

    <li *ngIf="isAdminUser">
      <a routerLink="/pdv-lista" routerLinkActive="active"
         class="nav-item" (click)="close()" title="{{ 'Lista de PDVs' | translate }}">
        <span class="nav-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
               fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
            <circle cx="12" cy="10" r="3"/>
          </svg>
        </span>
        <span class="nav-label">{{ 'Lista de PDVs' | translate }}</span>
      </a>
    </li>

    <li *ngIf="isAdminUser">
      <a routerLink="/zips-contagem" routerLinkActive="active"
         class="nav-item" (click)="close()" title="{{ 'Lista de arquivos em SFTP' | translate }}">
        <span class="nav-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
               fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 8v13H3V8"/>
            <path d="M1 3h22v5H1z"/>
            <path d="M10 12h4"/>
          </svg>
        </span>
        <span class="nav-label">{{ 'Lista de arquivos em SFTP' | translate }}</span>
      </a>
    </li>
  </ul>

  <div class="nav-bottom">
    <button class="nav-item nav-logout" (click)="logout()" title="{{ 'Logout' | translate }}">
      <span class="nav-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
             fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
          <polyline points="16 17 21 12 16 7"/>
          <line x1="21" y1="12" x2="9" y2="12"/>
        </svg>
      </span>
      <span class="nav-label">{{ 'Logout' | translate }}</span>
    </button>
  </div>
</nav>
